export default __webpack_public_path__ + "static/media/product-09 (2).00d45549.jpg";